import { render, staticRenderFns } from "./gonggao.vue?vue&type=template&id=7b8fea88"
import script from "./gonggao.vue?vue&type=script&lang=js"
export * from "./gonggao.vue?vue&type=script&lang=js"
import style0 from "./gonggao.vue?vue&type=style&index=0&id=7b8fea88&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports